import { SubscriptionPlanModel } from 'src/app/models/subscription-plan/SubscriptionPlanModel';
import { AuthSupportSummary, Subscription, User, Vehicle } from 'src/swagger-gen/web-secured/models';
import { SubPlanAssociationItemType } from '../enums/subPlanAssociationItemType';

export class SubPlanAssociationItemModel {
    type: SubPlanAssociationItemType;
    displayName: string;
    uid: string;
    badges: AuthSupportSummary[];
    subscriptionPlan: SubscriptionPlanModel;

    constructor(type: SubPlanAssociationItemType, item: User | Vehicle, subscriptionPlan: SubscriptionPlanModel) {
        this.type = type;
        this.uid = item?.uid || null;
        this.setDisplayName(item);
        this.setBadges(item, subscriptionPlan);
        this.subscriptionPlan = subscriptionPlan;
    }

    setDisplayName(item: User | Vehicle): void {
        if (this.type === SubPlanAssociationItemType.USER) {
            const user = item as User;
            let name = user?.lastName ? user.lastName + ' ' : '';
            name += user?.firstName || '';
            this.displayName = name;
        } else if (this.type === SubPlanAssociationItemType.VEHICLE) {
            const vehicle = item as Vehicle;
            const name = vehicle?.plateNumber || null;
            this.displayName = name;
        }

    }

    setBadges(user: any, subscriptionPlan: SubscriptionPlanModel): void {
        const list = [];
        if (user.subscriptionInfos) {
            const found = user.subscriptionInfos.find(subplan => subplan.uid === subscriptionPlan.uid);
            if (found) {
                const o = found.badgesInfos;
                list.push(o);
            }
        }

        this.badges = list;
    }
}
